// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader-loader-631a","small":"Loader-small-631a","scale":"Loader-scale-631a","white":"Loader-white-631a","scale-white":"Loader-scale-white-631a"};